module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail-overview padded-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('order-status-graph', {
    attrs: {
      "order-status": _vm.orderStatus
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.order-number')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.orderNumber))])])]), _vm._v(" "), (_vm.orderRef) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.customer-reference')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.orderRef))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.order-date')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.orderDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row delivery-date"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('div', [(_vm.orderDeliveryFrom && !_vm.orderDeliveryTo) ? _c('span', [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date-on', {
    onDate: _vm.formatDate(_vm.orderDeliveryTo)
  })))]) : _vm._e(), _vm._v(" "), (_vm.orderDeliveryFrom && _vm.orderDeliveryTo) ? _c('span', [_vm._v(_vm._s(_vm.orderDeliveryDate(_vm.orderDeliveryFrom, _vm.orderDeliveryTo)))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d51755d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetailOverview.vue
// module id = 301
// module chunks = 2